<template>
  <modal
    title="Clone this Goal"
    submit-button-text="Clone Goal"
    :show="show"
    size="md"
    :is-submitting="isSubmitting"
    @hidden="$emit('input', false)"
    @submit="onSubmit"
    :static="true"
    :lazy="true"
  >
    <div class="mb-4">
      <label for="timeline">Timeline for the cloned goal</label>
      <b-dropdown
        id="timeline"
        class="d-block ml-n2"
        variant="outline-default"
        menu-class="menu-shadow scrollable text-medium"
        toggle-class="rounded-pill dropdown-field text-truncate text-medium"
      >
        <template slot="button-content">
          <span>
            {{ getTimelineName(formData.timeline) }}
          </span>
        </template>
        <b-dropdown-item
          :active="formData.timeline === timeline"
          v-for="timeline in timelines"
          :key="timeline"
          @click="formData.timeline = timeline"
          >{{ getTimelineName(timeline) }}
        </b-dropdown-item>
      </b-dropdown>
    </div>
    <b-form-radio-group
      class="mb-4"
      v-model="formData.cloneOption"
      :options="cloneOptions"
      name="radios-stacked"
      stacked
    ></b-form-radio-group>
    <div class="clone-info">
      <div>When you clone a goal the following things happen</div>
      <ul class="clone-info">
        <li>Cloned goals have the same owners as original goals</li>
        <li>All goals and their KRs are cloned to the specified timeline</li>
      </ul>
    </div>
  </modal>
</template>

<script>
import { TOAST_TYPE } from '@/constants/toasts'
import EventBus from '@/EventBus'
import { getGoalPageRouteConfig } from '@/utils/navigationConfigs'
import * as R from 'ramda'
import { BDropdown, BDropdownItem, BFormRadioGroup } from 'bootstrap-vue'
import { DEFAULT_ERROR } from '@/constants/messages'
import urlManager from '@/urlManager'
import Modal from '@/components/Modal'
import service from '@/service'
import {
  currentAndFutureTimelines,
  filterIdForCreationId,
  intervalWithId,
  setDefaultIntervalId
} from '@/interval'

export default {
  name: 'CloneGoal',
  props: ['show', 'goalId'],
  model: {
    prop: 'show'
  },
  components: {
    Modal,
    BDropdown,
    BDropdownItem,
    BFormRadioGroup
  },
  data() {
    const timelines = currentAndFutureTimelines()
    return {
      timelines: timelines,
      cloneOptions: [
        { text: 'Clone just this goal', value: 'shallow' },
        { text: 'Clone this goal and all its child goals', value: 'deep' }
      ],
      formData: {
        timeline: timelines[0],
        cloneOption: 'shallow'
      },
      isSubmitting: false
    }
  },
  computed: {
    goal() {
      return this.$store.getters.goalById(this.goalId)
    }
  },
  methods: {
    async onSubmit() {
      const url = urlManager.cloneGoal({ goalId: this.goal.id, orgId: this.goal.organizationId })
      try {
        this.isSubmitting = true
        const { timeline, cloneOption } = this.formData
        const response = await service.client.post(url, {
          timeline,
          deep: cloneOption === 'deep'
        })
        EventBus.$emit('ADD_TOAST', {
          message: 'Goal has been cloned successfully'
        })
        setDefaultIntervalId(filterIdForCreationId(timeline))
        const location = getGoalPageRouteConfig({
          orgId: response.data.organizationId,
          goalId: response.data.id
        })
        this.$router.push(location)
      } catch (e) {
        const message = R.pathOr(DEFAULT_ERROR, ['response', 'data', 'message'], e)
        EventBus.$emit('ADD_TOAST', {
          message,
          type: TOAST_TYPE.ERROR
        })
      }
      this.isSubmitting = false
    },
    getTimelineName(id) {
      const interval = intervalWithId(id)
      return interval && interval.name
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

/deep/ .dropdown-field {
  border-color: $tertiary;
  min-width: 150px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

ul {
  padding-left: 20px;
  padding-top: 8px;
}
</style>
